import Drawer from '@material-ui/core/Drawer';
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useState} from 'react';

import {run as runUrl} from '../../../../util/urls';
import {ResizableDrawer} from '../../../common/ResizableDrawer/ResizableDrawer';
import {RunQueueItem} from '../../types';
import {RunQueueItemConfiguration} from './RunQueueItemConfiguration';
import {RunQueueItemIssues} from './RunQueueItemIssues';
import {RunQueueItemOverview} from './RunQueueItemOverview';

export type RunQueueItemInfoDrawerProps = {
  open: boolean;
  index: number;
  maxIndex: number;
  runQueueItem: RunQueueItem;
  nextViewedItem: () => void;
  previousViewedItem: () => void;
  onClose: () => void;
};

export const RunQueueItemInfoDrawer = ({
  open,
  runQueueItem,
  index,
  maxIndex,
  nextViewedItem,
  previousViewedItem,
  onClose,
}: RunQueueItemInfoDrawerProps) => {
  const [width, setWidth] = useState(800); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };

  const {entityName, projectName, run} = runQueueItem;
  const nextChevronPointer = index === maxIndex ? '' : 'cursor-pointer';
  const nextChevronColor = index === maxIndex ? 'gray' : 'black';
  const prevChevronPointer = index === 0 ? '' : 'cursor-pointer';
  const prevChevronColor = index === 0 ? 'gray' : 'black';
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <ResizableDrawer
        startWidth={width}
        minWidth={400}
        onSetWidth={onSetWidth}>
        <Tailwind>
          <div className="mt-[60px]">
            <div className="relative mx-auto h-64">
              <div
                className="fixed z-10 mb-8 w-full bg-white pt-8"
                style={{width}}>
                <div className="flex w-full flex-row items-center">
                  <Icon
                    className={`mx-8 ${prevChevronPointer}`}
                    color={prevChevronColor}
                    name="chevron-back"
                    onClick={previousViewedItem}
                  />
                  <Icon
                    className={`mx-8 ${nextChevronPointer}`}
                    color={nextChevronColor}
                    name="chevron-next"
                    onClick={nextViewedItem}
                  />
                  <div className="font-sans text-2xl font-semibold leading-[40px]">
                    {run?.displayName ?? runQueueItem.associatedRunId ?? ''}
                  </div>
                  <div className="my-4 mr-4 grid min-w-0 flex-1 items-center justify-items-end">
                    <div className="flex text-right">
                      {run != null && (
                        <div className="mt-4">
                          <TargetBlank
                            href={runUrl({
                              entityName,
                              projectName,
                              name: run.name,
                            })}>
                            <Button variant="secondary">View in Project</Button>
                          </TargetBlank>
                        </div>
                      )}
                      <Button
                        data-test="rqi-info-drawer-close"
                        onClick={onClose}
                        icon="close"
                        size="large"
                        variant="ghost"
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-8"></div>
                <div className="absolute m-0 h-px w-full bg-moon-250 p-0 " />
              </div>
            </div>
            <RunQueueItemOverview runQueueItem={runQueueItem} />
            <div className="absolute m-0 h-px w-full bg-moon-250 p-0 " />
            <RunQueueItemConfiguration runQueueItem={runQueueItem} />
            <div className="absolute m-0 h-px w-full bg-moon-250 p-0 " />
            <RunQueueItemIssues runQueueItem={runQueueItem} />
            <div>
              <div className="absolute m-0 h-px w-full bg-moon-250 p-0 " />
              <Button
                className="my-16 w-full"
                variant="primary"
                size="large"
                onClick={onClose}>
                Done
              </Button>
            </div>
          </div>
        </Tailwind>
      </ResizableDrawer>
    </Drawer>
  );
};
